import React, { Component } from "react";
import RST_pull_annotations from '../RST_pull_annotations.png';
import RST_push_annotations from '../RST_push_annotations.png';

export default class CoachSection extends Component {
    constructor(props) {
        super(props)

        this.renderCoachingSection = this.renderCoachingSection.bind(this);
        this.renderImageCoachingSection = this.renderImageCoachingSection.bind(this);
    }

    renderImageCoachingSection() {
        const { activeTrainingZone } = this.props;
        if (activeTrainingZone === "Technical Competency") {
            return (
                <div className="imgCoachingWrapper">
                    <h3 className="heading3Coach">{'Optimal technique'}</h3>
                    <div className="imgCoachingContainer">
                        <img className={"imgCoaching"} name={"RST_pull_annotations"} src={RST_pull_annotations} alt="rst_pull" onClick={this.handleClick} />
                    </div>
                </div>
            )
        }
        else {
            return (
                <div className="imgCoachingWrapper">
                    <h3 className="heading3Coach">{'Optimal technique'}</h3>
                    <div className="imgCoachingContainer">
                        <img className={"imgCoaching"} name={"RST_pull_annotations"} src={RST_pull_annotations} alt="rst_pull" onClick={this.handleClick} />
                        <img className={"imgCoaching"} name={"RST_push_annotations"} src={RST_push_annotations} alt="rst_push" onClick={this.handleClick} />
                    </div>
                </div>
            )
        }
    }



    renderCoachingSection() {
        const { activeTrainingZone } = this.props;
        var { trainingZoneEmphasis, CoachingTips, Guidelines } = [];

        switch (activeTrainingZone) {
            case "Technical Competency":
                trainingZoneEmphasis = "The purpose of training within the technical competency zone is to add a resistive load while minimally disrupting sprint mechanics. Due to the use of the arms and base weight of most push sleds, this zone does not apply to sled pushing. The technical competency zone of training might more useful by track sprinters to add resistive stimulus at certain times of the year while maintaining technical sprint mechanics.";
                CoachingTips = "Coaches should ensure the load employed does not alter the desired sprint mechanics and should adjust within the <10% Vdec threshold accordingly.";
                Guidelines = "Recommended distances for this zone of training are approximately 27.5 - 32.5 m with rest intervals of 3 minutes between repetitions. Each maximal effort repetition should not exceed 5 seconds.";
                break;
            case "Speed Strength":
                trainingZoneEmphasis = "The speed-strength zone of training can be used in both forms of RST to target the transition to Vmax phase of sprinting, however it is much more specific in sled pulling. It can also be used as a developmental strength phase to introduce RST to young athletes, specifically less mature or less competent athletes.";
                CoachingTips = "Caution on technique and body angles is recommended when sled pushing within this zone of training. For stronger more mature athletes this zone of training may not provide enough anterior resistance during sled pushing to ensure proper mechanics at higher velocities. Practitioners can incorporate drills to coach areas such as the forward lean, proper postural control and knee drive. Emphasis on such areas could be particularly useful for less advanced athletes as sprinting technique should be a focus point.";
                Guidelines = "Recommended distances for this zone of training are approximately 20 - 25 m with rest intervals of 3 minutes between repetitions. Each maximal effort repetition should not exceed 5 seconds.";
                break;
            case "Power":
                trainingZoneEmphasis = "The purpose of training within a zone of power is to optimize adaptation to maximal power (Pmax). This zone of training can be used in RST to target the late acceleration phase of sprinting. Even though this zone is considered the optimal load for RST that maximizes power production, it does not necessarily ensure optimal gains in short distance performance. Just like any exercise selected, it is task-specific and dependent on the individual force velocity characteristics of the athlete.";
                CoachingTips = "Caution is advised during sled pushing to ensure there is not excessive rounding of the back or breaking of the hips due to inability to maintain forward lean throughout the sprint. During sled pulling the waist belt can act as an external coaching cue to push the hips into extension; however, excessive loading may lead to a break in the hips causing a less optimal body lean angle which negatively effects the orientation of the foot strike.";
                Guidelines = "Recommended distances for this zone of training are approximately 12.5 - 17. 5 m with rest intervals of 3 minutes between repetitions. Each maximal effort repetition should not exceed 5 seconds.";
                break;
            case "Strength Speed":
                trainingZoneEmphasis = "The purpose of the strength-speed zone of training is to maximize the rate of force development. This zone of training can be used in both RST conditions to target the initial acceleration phase.";
                CoachingTips = "During heavy sled pushing,  athletes may be better able to maintain hip position, postural control and lower limb alignment as compared to pulling heavy loads, but without an arm drive this training mode renders sled pushing less specific to sprinting in comparison to sled pulling. Therefore, sled pushing may be favored as a form of very heavy RST over sled pulling initially during the early preparatory phase to increase total body horizontal strength rather than sprint specific application of force. However, sled pulling should be prioritized over sled pushing for sprint specific strength adaptations if the coach has seasonal time constraints across all zones.";
                Guidelines = "Recommended distances for this zone of training are approximately 5 - 10 m with rest intervals of 3 minutes between repetitions. Each maximal effort repetition should not exceed 5 seconds.";
                break;
            default:
                break;
        }

        return (
            <div>
                <div className="coachingText">
                    <h3 className="heading3Coach">Training Zone Emphasis</h3>
                    <p>{trainingZoneEmphasis}</p>
                </div>
                <div className="coachingText">
                    <h3 className="heading3Coach">Coaching/Technique Tips</h3>
                    <p>{CoachingTips}</p>
                </div>
                <div className="coachingText">
                    <h3 className="heading3Coach">Training Guidelines</h3>
                    <p>{Guidelines}</p>
                </div>
            </div >
        )
    }

    render() {

        return (
            <div className="coach-row">
                <h3 className="heading3">Step 4 - Coach : Ensure optimal technique and training guidelines</h3>
                {this.renderImageCoachingSection()}
                {this.renderCoachingSection()}
            </div>

        );
    }
}
